import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Box } from '@mui/material';

import useChatFunctions from 'app/features/chat/hooks/useChatFunctions';
import { useGetContactsQuery } from 'app/features/chat/chatApi';
import ContactListItem from './ContactListItem';

import {
  useGetAdvisorsQuery,
  useGetAppConfigQuery,
} from 'app/api/mainApi';

const ContactListContainer = () => {
  const { data: contactsData } = useGetContactsQuery();
  const { slug } = useParams();
  const currentUser = useGetAppConfigQuery().data?.current_user;
  const { setCurrentContactBySlug } = useChatFunctions();

  let advisorIds = [];
  if (!currentUser?.is_advisor && contactsData) {
    advisorIds = contactsData.contacts.map((contact) => contact.other_user.id);
  }

  const { data: advisors } = useGetAdvisorsQuery({ ids: advisorIds }, {
    skip: !currentUser || currentUser.is_advisor || !advisorIds.length,
  });

  useEffect(() => {
    if (contactsData) {
      // we might have a slug from the url, but if not
      // we can just take the first contact from our list
      // and set it as current
      setCurrentContactBySlug(slug || contactsData.contacts[0]?.other_user.slug);
    }
  }, [contactsData]);

  return (
    <Box className="CONTACT-LIST-CONATAINER">
      {contactsData?.contacts.map((contact) => {
        let advisor;
        if (!currentUser?.is_advisor && advisors) {
          advisor = advisors.find((advisor) => {
            return advisor.id === contact.other_user.id;
          });
        }

        return (
          <ContactListItem
            key={contact.id}
            contact={contact}
            advisor={advisor}
          />
        );
      })}
    </Box>
  );
};

export default ContactListContainer;
